import { cn } from '@/lib/cn';

interface FieldProps {
  label?: React.ReactNode;
  hint?: React.ReactNode;
  error?: React.ReactNode;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

export function Field(props: FieldProps) {
  const { label, hint, error, required, className, children } = props;
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label && (
        <label className="text-xs font-medium text-brand-700">
          {label}
          {required && <span className="ml-0.5 text-red-600">*</span>}
        </label>
      )}
      {children}
      {(hint || error) && (
        <p
          className={cn(
            'text-xs',
            error ? 'text-red-600' : 'text-brand-500',
          )}
        >
          {error ?? hint}
        </p>
      )}
    </div>
  );
}
